import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
  fetchOtherVendorsList,
  clearOtherVendorsError,
  onChangeVendorView
} from '../../../actions/vendors/otherVendors';
import './other-vendors.scss';
import {
  getOtherVendors,
  getOtherVendorsLoading,
  getOtherVendorsError,
  getOtherVendorsCount
} from '../../../selectors/otherVendors';
import { ITEMS_GRID_VIEW } from '../../../constants';

import { VendorsFilters } from './components/VendorsFilters';
import { VendorGrid } from './components/VendorGrid';
import VendorTitle from './components/VendorTitle';
import VendorList from './components/VendorList';



export const OtherVendorsMain: React.FC<any> = ({
  onChangeVendorView,
  vendors,
  user,
}) => {
  const dispatch = useDispatch();
  const vendorsList = useSelector(getOtherVendors);
  const loading = useSelector(getOtherVendorsLoading);
  const error = useSelector(getOtherVendorsError);
  const vendorsCount = useSelector(getOtherVendorsCount);

  // Get viewType with fallback
  const viewType = vendors?.viewType || ITEMS_GRID_VIEW;
  const [searchText, setSearchText] = useState('');
  const [debouncedSearchText, setDebouncedSearchText] = useState('');

  // Initial load
  useEffect(() => {
    dispatch(fetchOtherVendorsList() as any);
  }, [dispatch]);

  // Debounce search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchText]);

  // Fetch vendors when debounced search text changes
  useEffect(() => {
    dispatch(fetchOtherVendorsList(debouncedSearchText || undefined) as any);
  }, [debouncedSearchText, dispatch]);

  const handleRetry = () => {
    dispatch(clearOtherVendorsError());
    dispatch(fetchOtherVendorsList(debouncedSearchText || undefined) as any);
  };

  // Mock send function for UI compatibility
  const mockSend = (action: any) => {
    if (action.type === 'addQueryStringValue' && action.key === 'searchString') {
      setSearchText(action.value);
    }
  };

  // Mock state object for UI compatibility
  const mockState = {
    context: {
      records: vendorsList,
      totalRecords: vendorsList.length,
      pageNumber: 1,
      pageSize: 100,
      additionalQueryStringValues: {
        orderBy: 'name',
        sortOrder: 'asc'
      }
    },
    hasTag: (tag: string) => tag === 'loading' ? loading : false
  };

  return (
    <div>
      <VendorTitle />

      <div className="container">
        <VendorsFilters
          onChangeVendorView={onChangeVendorView}
          viewType={viewType}
          searchText={searchText}
          setSearchText={setSearchText}
          send={mockSend}
        />
        <div>
          {viewType === ITEMS_GRID_VIEW ? (
            <VendorGrid
              vendorsList={vendorsList}
              state={mockState}
              send={mockSend}
            />
          ) : (
            <VendorList
              vendorsList={vendorsList}
              user={user}
              state={mockState}
              send={mockSend}
            />
          )}
        </div>
      </div>
    </div>
  );
};
